<template>
  <div class="main">
    <div class="form-row">
      <div class="form-field">
        <label for="service-select">Выберите услугу:</label>
        <select id="service-select" v-model="newRules.SERVICE">
          <option
            v-for="(service, key) in services"
            :value="service.ID"
            :key="key"
          >
            {{ service.NAME }}
          </option>
        </select>
      </div>
      <div class="form-field">
        <label for="village-select">Выберите поселок:</label>
        <select id="village-select" @change="getPlots" v-model="village">
          <option
            v-for="(village, key) in villages"
            :value="village.ID"
            :key="key"
          >
            {{ village.NAME }}
          </option>
        </select>
      </div>
      <div class="form-field" v-show="village">
        <label for="plot-select">Выберите участок:</label>
        <select id="plot-select" v-model="newRules.PLOT">
          <option v-for="(plot, key) in plots" :value="plot.ID" :key="key">
            {{ plot.NAME }}
          </option>
        </select>
      </div>
      <div class="form-field">
        <label for="date_input">Дата начислений:</label>
        <input id="date_input" v-model="newRules.DATE" type="number" />
      </div>
      <div class="form-field">
        <label for="sum_input">Сумма начислений:</label>
        <input id="sum_input" v-model="newRules.SUM" />
      </div>
      <div class="form-field">
        <button @click="sendRulesData">Добавить</button>
      </div>
    </div>
    <div class="form-row" v-if="info">{{ info }}</div>
  </div>
</template>

<script>
import config from "@/config";

export default {
  name: "addAccrualRules",

  data() {
    return {
      url: config.backend_url,
      info: null,
      village: null,
      villages: [],
      plots: [],
      services: [],
      newRules: {
        SERVICE: null,
        PLOT: null,
        DATE: null,
        SUM: null
      }
    };
  },
  computed: {},
  methods: {
    getServices: function() {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "services/get/",
          data: {},
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            self.services = data;
          }
        });
    },
    getVillages: function() {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "villages/get/",
          data: {},
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            self.villages = data;
          }
        });
    },
    getPlots: function() {
      let self = this;
      this.newRules.DATE = parseInt(
        this.villages[this.village]["DATE_ACCRUAL"]
      );
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "plots/get/",
          filter: { VILLAGE: self.village },
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            self.plots = data;
          }
        });
    },
    sendRulesData: function() {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "accrualrules/add/",
          data: this.newRules,
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (data.accrualrules) {
            self.info = "Правило успешно добавлено";
            self.$emit("rules-add");
          }
        });
    }
  },
  created() {
    this.getVillages();
    this.getServices();
  }
};
</script>
